const isIE11 = () => !!window.MSInputMethodContext && !!document.documentMode

module.exports = { isIE11 }
